import React from "react"

import Layout from "../../../components/shared/layout"
import Hero from "../../../components/shared/hero"
import useHeroMapImages from "../../../components/map-editor/useHeroMapImages"
import { HeroOverlay } from "../../../components/map-editor/hero.style"
import SEO from "../../../components/shared/seo"
import LocationData from "../../../components/map-editor/location-data"
import MapAccuracy from "../../../components/map-editor/map-accuracy"
import AdditionalBenefits from "../../../components/map-editor/additional-benefits"
import Analytics from "../../../components/map-editor/analytics"
import BlogFeatures from "../../../components/map-editor/blog-features"
import ContactUs from "../../../components/shared/contact"
import Footer from "../../../components/shared/footer"

export default function MapEditorPage({ location }) {
  const images = useHeroMapImages()
  return (
    <Layout location={location}>
      <SEO
        title="Indoor Map Editor | Custom Maps for Your Venue"
        description="Our Map Editor helps you edit indoor maps, update location names, add promotions and events, and deploy changes in real-time across mapping platforms."
      />
      <Hero
        overlayStyle={HeroOverlay}
        title={"Map Editor"}
        sizes={images}
        description={
          "Mappedin’s Map Editor acts as a centralized management tool for our clients to edit their venue maps and maintain the most up-to-date location information. Our tools enable property operators to power accurate maps across more than 755+ million square feet of premium space worldwide."
        }
      />
      <LocationData />
      <MapAccuracy />
      <AdditionalBenefits />
      <Analytics />
      <BlogFeatures />
      <ContactUs />
      <Footer />
    </Layout>
  )
}
